import React, {useContext, useState} from "react";
import Modal from "../../components/Modal/Modal";
import {GenerateForm} from "../../components/cardViewComponents/GenerateForm";
import {validationData} from "../../components/UI/formValid";
import {validationConfig} from "../../components/cardViewComponents/validationConfig";
import Notif from "../../components/Notif";
import {createContactService} from "../../services/contact/contactService";
import {GlobalState} from "../../Layout/Layout";
import {createEvent} from "../../services/other/events";

const fieldsConfig = {
    first_name: {
        label: 'Имя',
        type: 'text',
        className: 'w100',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    last_name: {
        label: 'Фамилия',
        type: 'text',
        className: 'w100',
        validation: { maxLength: 255 }, zone: 1
    },
    email: {
        label: 'Email',
        type: 'text',
        className: 'w100',
        validation: { email: true, maxLength: 255 }, zone: 1
    },
    mobile_phone: {
        label: 'Номер телефона',
        type: 'text',
        className: 'w100',
        validation: { maxLength: 255 }, zone: 1
    },
    type_id: {
        label: 'Тип контакта',
        type: 'entity',
        link: "/ajax/lookup/search?type=ct_type&value=",
        result: 'value',
        entity_from: 'type',
        entityName: 'value',
        className: 'w100',
        minLength: 0, zone: 1
    },
    owner_id: {
        label: 'Ответственный',
        type: 'entity',
        link: "/ajax/settings/user?filter[name][like]=",
        result: 'name',
        entity_from: 'owner',
        entityName: 'name',
        className: 'w100',
        minLength: 0, zone: 1
    },
}

export const ContactModal = ({ isOpen, close, history, setStep }) => {
    const { setSteps } = useContext(GlobalState)
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({})
    const [disabled, setDisabled] = useState({})
    const [values, setValues] = useState({
        first_name: '',
        last_name: '',
        email: '',
        mobile_phone: '',
        owner_id: null,
        owner: null,
        type_id: null,
        type: null,
        tch: true
    })

    const saveItem = async () => {
        const errorsData = validationData(values, validationConfig(fieldsConfig));
        setErrors(errorsData)
        if(Object.keys(errorsData).length > 0) {
            Notif('required-fields')
            return false;
        }

        setLoading(true)
        const { first_name, last_name, email, mobile_phone, owner_id, type_id } = values
        const { status, data } = await createContactService({data: { first_name, last_name, email, mobile_phone, owner_id, type_id }})
        if((status === 200 || status === 201) && data.id) {
            history.push(`/contact/${data.id}`)
            setSteps("contact", true, true)
            createEvent({ user_id: window.location.host, user_name: "---", event_type: "createContact" }).then()
        }
        setLoading(false)
    }


    const changeFields = (key, value, item) => {
        let obj = {}
        if(item) {
            if(item === 'clear') obj[fieldsConfig[key].entity_from] = null
            else obj[fieldsConfig[key].entity_from] = item
        }

        setValues({ ...values, ...obj, [key]: item ? item.id : value, tch: false })
    }

    return (
        <Modal isOpen={isOpen} save={saveItem} close={close} loading={loading} showLeaveModal tch={values.tch} title={'Создать контакт'}>
            <GenerateForm
                config={fieldsConfig}
                { ...{ values, errors, disabled } }
                onChange={changeFields}
                onSaveData={saveItem}
            />
        </Modal>
    )
}